import React from "react"

import dayjs from "src/dayjs"

import LocalTime from "components/LocalTime"

type AcrClassPeriod = {
  id: string
  startsAt: string
  endsAt: string
  acrClass: {
    id: string
    name: string
    roomUrl: string
    subject: {
      name: string
    }
    teacher: {
      name: string
    }
  }
}

const TodaysAcrClassPeriods: React.FC<{
  acrClassPeriods: AcrClassPeriod[]
}> = ({ acrClassPeriods: periods }) => {
  return (
    <section>
      <h2 className="font-bold">Air Classroom</h2>
      {periods.length > 0 ? (
        <>
          <h3>Today's Classes</h3>
          <table className="table-striped table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Subject</th>
                <th>Time</th>
                <th>Teacher</th>
              </tr>
            </thead>
            <tbody>
              {periods.map(period => (
                <tr key={period.id}>
                  <td className="align-middle">{period.acrClass.name}</td>
                  <td className="align-middle">
                    {period.acrClass.subject.name}
                  </td>
                  <td className="align-middle">
                    <LocalTime omitDate timestamp={period.startsAt} />
                    &nbsp;&mdash;&nbsp;
                    <LocalTime omitDate timestamp={period.endsAt} />
                  </td>
                  <td className="align-middle">
                    {period.acrClass.teacher.name}
                  </td>
                  <td>
                    {dayjs().isBetween(
                      dayjs(period.startsAt).subtract(2, "minutes"),
                      dayjs(period.endsAt)
                    ) && (
                      <a
                        href={period.acrClass.roomUrl}
                        className="btn solid blue"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Join Class
                      </a>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        <p>No classes scheduled for today</p>
      )}
      <hr className="bg-gray-300" />
    </section>
  )
}

export default TodaysAcrClassPeriods
